import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";

const LandingMaxLauout = () => {
  const path = window.location.pathname;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  return (
    <div className="bg-white text-black font-change">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default LandingMaxLauout;
